import { Stack, Textarea } from '@mantine/core';
import { useUpdateLead, type Lead } from '@/models/leads';
import { FormSaveBar } from '@/components/FormSaveBar';
import { CollapsibleCard } from '@/components/CollapsibleCard';
import { useCardForm } from '@/lib/useCardForm';

type Values = {
  request: string;
  extendedMessage: string;
};

export function RequestNotesCard({
  lead,
  readOnly,
}: {
  lead: Lead;
  readOnly: boolean;
}) {
  const update = useUpdateLead();
  const { form, dirty, saving, handleSubmit } = useCardForm<Values>({
    initialValues: {
      request: lead.request ?? '',
      extendedMessage: lead.extendedMessage ?? '',
    },
    enabled: !readOnly,
    save: (dirtyValues) => update.mutateAsync({ id: lead.id, ...dirtyValues }),
    successMessage: 'Request & notes saved',
  });

  return (
    <CollapsibleCard title="Request & Notes">
      <form onSubmit={handleSubmit}>
        <Stack gap="xs">
          <Textarea
            label="Original request"
            size="xs"
            autosize
            minRows={2}
            disabled={readOnly}
            {...form.getInputProps('request')}
          />
          <Textarea
            label="Notes"
            size="xs"
            autosize
            minRows={2}
            disabled={readOnly}
            {...form.getInputProps('extendedMessage')}
          />
          {dirty && !readOnly && (
            <FormSaveBar saving={saving} onDiscard={form.reset} />
          )}
        </Stack>
      </form>
    </CollapsibleCard>
  );
}
